<div
  #rails
  class="wfm-scrollbar-rails"
  [id]="id"
  [ngClass]="orientation"
  [class.small]="small"
  [class.hidden]="hidden"
  (resized)="resized()"
  (mousedown)="mouseDownOnRails($event)"
  (wfmOutsideMousedown)="blur()"
>
  <div
    #handler
    class="wfm-scrollbar-handler"
    [ngStyle]="style"
    (mousedown)="mouseMoveStart($event); $event.preventDefault()"
  ></div>
</div>
